import { getAllRole } from "@/api/role";
import { useQuery } from "@tanstack/react-query";

type UseRolesProps = {
  page?: number;
  size?: number;
  search?: string;
  enabled?: boolean;
};

export const useRoles = ({
  page = 1,
  size = 20,
  search = "",
  enabled = true
}: UseRolesProps = {}) => {
  return useQuery({
    queryKey: ["roles", page, size, search],
    queryFn: () =>
      getAllRole({
        page,
        size,
        search
      }),
    enabled
  });
};
